// EmailJS Configuration
// To set up EmailJS:
// 1. Go to https://www.emailjs.com/
// 2. Create an account and verify your email
// 3. Create a new service (Gmail, Outlook, etc.)
// 4. Create an email template
// 5. Get your service ID, template ID, and public key
// 6. Replace the values below with your actual credentials

export const EMAILJS_CONFIG = {
  serviceId: 'service_92sdail', // Replace with your EmailJS service ID
  templateId: 'template_fsiwj6k', // Replace with your EmailJS template ID
  publicKey: 'Te0XwKfPP7xw4AUDh', // Replace with your EmailJS public key
  toEmail: 'hodlwarden@gmail.com' // Your email address where messages will be sent
};

// EmailJS template variables mapping
export const EMAILJS_TEMPLATE_PARAMS = {
  from_name: '{{from_name}}',
  from_email: '{{from_email}}',
  subject: '{{subject}}',
  message: '{{message}}',
  to_email: '{{to_email}}'
};
